// Left half: virtual joystick (move). Right half: look (yaw/pitch).
export class TouchLookFPS {
    constructor(dom) {
        this.moveId = null;
        this.lookId = null;
        this.moveStartX = 0;
        this.moveStartY = 0;
        this.moveX = 0;
        this.moveY = 0;
        this.accYaw = 0;
        this.accPitch = 0;
        this.moveMaxRadius = 64; // px for full input
        this.lookSensitivity = 0.003; // rad per px
        this.dom = dom;
    }
    enable() {
        this.dom.style.touchAction = 'none';
        const onTouchStart = (e) => {
            for (const t of Array.from(e.changedTouches)) {
                const isLeft = t.clientX < window.innerWidth * 0.5;
                if (isLeft && this.moveId === null) {
                    this.moveId = t.identifier;
                    this.moveStartX = t.clientX;
                    this.moveStartY = t.clientY;
                    this.moveX = t.clientX;
                    this.moveY = t.clientY;
                }
                else if (!isLeft && this.lookId === null) {
                    this.lookId = t.identifier;
                    t._lx = t.clientX;
                    t._ly = t.clientY;
                }
            }
            if (e.changedTouches.length)
                e.preventDefault();
        };
        const onTouchMove = (e) => {
            var _a, _b;
            for (const t of Array.from(e.changedTouches)) {
                if (t.identifier === this.moveId) {
                    this.moveX = t.clientX;
                    this.moveY = t.clientY;
                }
                else if (t.identifier === this.lookId) {
                    const lx = (_a = t._lx) !== null && _a !== void 0 ? _a : t.clientX;
                    const ly = (_b = t._ly) !== null && _b !== void 0 ? _b : t.clientY;
                    this.accYaw += -(t.clientX - lx) * this.lookSensitivity;
                    this.accPitch += -(t.clientY - ly) * this.lookSensitivity;
                    t._lx = t.clientX;
                    t._ly = t.clientY;
                }
            }
            if (e.changedTouches.length)
                e.preventDefault();
        };
        const onTouchEnd = (e) => {
            for (const t of Array.from(e.changedTouches)) {
                if (this.moveId === t.identifier)
                    this.moveId = null;
                if (this.lookId === t.identifier)
                    this.lookId = null;
            }
            if (e.changedTouches.length)
                e.preventDefault();
        };
        this._h = { onTouchStart, onTouchMove, onTouchEnd };
        this.dom.addEventListener('touchstart', onTouchStart, { passive: false });
        this.dom.addEventListener('touchmove', onTouchMove, { passive: false });
        this.dom.addEventListener('touchend', onTouchEnd, { passive: false });
        this.dom.addEventListener('touchcancel', onTouchEnd, { passive: false });
    }
    disable() {
        const h = this._h;
        if (!h)
            return;
        this.dom.removeEventListener('touchstart', h.onTouchStart);
        this.dom.removeEventListener('touchmove', h.onTouchMove);
        this.dom.removeEventListener('touchend', h.onTouchEnd);
        this.dom.removeEventListener('touchcancel', h.onTouchEnd);
        this._h = undefined;
        this.moveId = this.lookId = null;
    }
    sample() {
        // movement input (normalized by joystick radius)
        let leftRight = 0, fwdBack = 0;
        if (this.moveId !== null) {
            const dx = this.moveX - this.moveStartX;
            const dy = this.moveY - this.moveStartY;
            const r = Math.hypot(dx, dy);
            const clamp = Math.min(1, r / this.moveMaxRadius);
            const nx = r > 0 ? (dx / r) * clamp : 0;
            const ny = r > 0 ? (dy / r) * clamp : 0;
            leftRight = nx; // right positive
            fwdBack = -ny; // up on screen → forward
        }
        const out = {
            moveForwardBack: fwdBack,
            moveLeftRight: leftRight,
            moveUpDown: 0,
            deltaYaw: this.accYaw,
            deltaPitch: this.accPitch
        };
        this.accYaw = 0;
        this.accPitch = 0;
        return out;
    }
}
